import React from 'react';

import './index.css';
import './gradients.css'
import GreetingPlayer from "../utils/player-v2/greeting-player";
import moment from "moment";
// import Countdown from "react-countdown";
import API from "../utils/api";
import Modal from "../modal";
import Player from "./player";

class Greeting extends React.Component {
    constructor (props) {
        super();

        this.state = {
            orders: null,
            orderIdx: 0,
            playHover: false,
            playing: false,
            iceRemoved: false,
            iceHidden: false,
            date: moment('2020-12-31').valueOf(),
            loaded: false,
            greeting: null,
            event: null,
            nowPlaying: null,
            orderStatus: null,
            orderId: null,
            modalPurchaseLink: null
        };
    }

    componentDidMount() {
        const t = this;
        const p = t.props;
        const userData = p.userData;

        if (userData.show_data && userData.show_data.date) {
            t.setState({
                date: moment(userData.show_data.date, 'DD.MM.YYYY HH:mm').valueOf(),
                loaded: true
            });
        }

        t.loadGreetingData();
    }

    loadGreetingData = () => {
        const t = this;
        const {orders, orderIdx} = t.state;

        if (orders) {
            const order = orders[orderIdx];
            const ud = order.user_data;

            t.setState({
                date: moment(ud.date, 'DD.MM.YYYY HH:mm').valueOf(),
                orderStatus: order.status,
                orderId: order.id
            });

            if (order.status === 'completed') {
                t.setState({greeting: order['video_ready'], event: ud.event})
            }
        }
        else {
            t.loadOrders((r) => {
                if (!r.error) {
                    t.setState({loaded: true});
                    t.loadGreetingData();
                }
            });
        }
    };

    loadOrders = (cb) => {
        const t = this;
        API.get('/med/v3/dedmoroz')
            .then(function (r) {
                if (r.data.orders && r.data.orders.length) {
                    t.setState({orders: r.data.orders}, () => {
                        cb({});
                    });
                }
            })
            .catch(function (error) {
                console.log(error.response);
                cb({error: true})
            });
    };

    countdownRenderer = ({ days, hours, minutes, seconds }) => {
        // if (completed) {
        //     // Render a completed state
        //     return <Completionist />;
        // } else {
        //     // Render a countdown
        // }
        let oDays = days,
            oHours = hours,
            oMins = minutes,
            oSecs = seconds;

        if (days < 10 ) {
            oDays = '0' + days;
        }
        if (hours < 10 ) {
            oHours = '0' + hours;
        }
        if (minutes < 10 ) {
            oMins = '0' + minutes;
        }
        if (seconds < 10 ) {
            oSecs = '0' + seconds;
        }

        let output = <span>{oDays}:{oHours}:{oMins}:{oSecs}</span>;
        if (!days) {
            output = <span>{oHours}:{oMins}:{oSecs}</span>;

            if (!hours) {
                output = <span>{oMins}:{oSecs}</span>;
            }
        }

        return output;
    };

    handleMouseEnter = () => {
        this.setState({playHover: true});
    };

    handleMouseLeave = () => {
        this.setState({playHover: false});
    };

    handleClick = () => {
        this.setState({playing: !this.state.playing});
    };

    removeIce = () => {
        const t = this;

        t.setState({iceHidden: true, iceRemoved: true})
    };

    addIce = () => {
        const t = this;

        t.setState({iceHidden: false}, () => {
            setTimeout(() => {
                t.setState({iceRemoved: false});
            }, 800);
        })
    };

    playGreeting = () => {
        const t = this;
        const {greeting} = t.state;

        t.setState({nowPlaying: greeting['url_1080p_mp4']});
    };
    playShow = () => {
        const t = this;
        const {event} = t.state;

        const showUrls = {
            izum_gorod: 'https://vimeo.com/489929802/f67f1a17e4',
            alisa: 'https://vimeo.com/489926061/a4871ebc2f'
        };

        t.setState({nowPlaying: showUrls[event]});
    };

    hideModal = () => {
        this.setState({nowPlaying: null, modalPurchaseLink: null});
    };

    initPayment = () => {
        const t = this;
        const {orderId} = t.state;
        // /med/v3/dedmoroz/{{id}}
        API.patch('/med/v3/dedmoroz/' + orderId)
            .then(function (r) {
                if (r.data.result) {
                    t.processPayment(r.data.result);
                }
            })
            .catch(function (error) {
                console.log(error.response);
            });
    };

    processPayment = (url) => {
        const t = this;
        t.setState({modalPurchaseLink: url});
        window.open(url);
    };

    render() {
        const t = this;
        const s = t.state;

        const isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;

        const cls_scaled = s.playHover ? 'scaled' : '';
        const cls_ice_hidden = s.iceHidden ? 'hidden' : '';

        const cls_global_playing = s.iceRemoved ? 'playing' : '';

        const started = s.greeting;

        const loader = <div className="flake_loader">
            <svg width="58.789" height="64" viewBox="0 0 58.789 64">
                <g transform="translate(0 0)">
                    <g transform="translate(0 0)">
                        <path fill="#fff"
                              d="M55.977,50.366a.741.741,0,0,1-1.026.194l-5.734-3.887.638,3.523a.736.736,0,0,1-1.312.565.76.76,0,0,1-.14-.31l-.887-4.938-5.679-3.845,1.172,6.463a.739.739,0,0,1-1.312.577.821.821,0,0,1-.146-.322l-1.427-7.878-5.387-3.65,1.2,6.542,2.01,2.01a.73.73,0,0,1-.006,1.033.9.9,0,0,1-.164.1.718.718,0,0,1-.881-.1l-.5-.5.188,1.057a.731.731,0,0,1-.6.856h-.006a.745.745,0,0,1-.7-.279.65.65,0,0,1-.14-.316L34.554,44.1l-5.236-5.236L28.8,45.683l5.242,5.952h-.006a.718.718,0,0,1-.067,1.026A.745.745,0,0,1,32.92,52.6l-4.282-4.871-.516,6.784L31.378,58.2v.006a.731.731,0,0,1-.067,1.033.752.752,0,0,1-1.045-.073l-2.3-2.612-.516,6.766a.737.737,0,0,1-1.47-.109l.528-6.87-2.758,2.314a.738.738,0,0,1-1.033-.091.722.722,0,0,1-.128-.747.674.674,0,0,1,.207-.279L26.658,54.3l.516-6.791-5.06,4.233a.733.733,0,0,1-1.154-.838.66.66,0,0,1,.207-.279l6.165-5.169.492-6.438L22.71,43.3l-.747,2.727a.734.734,0,0,1-.911.516,1.056,1.056,0,0,1-.164-.085.73.73,0,0,1-.352-.808l.188-.692-.826.7a.746.746,0,0,1-1.045-.085v-.006a.763.763,0,0,1-.121-.747.731.731,0,0,1,.213-.279l2.46-2.065,1.944-7.112-6.2,2.958-2.575,7.471h-.006a.738.738,0,0,1-1.4-.474L15.276,39.2,9.1,42.148l-1.6,4.64a.741.741,0,0,1-1.4-.474l1.142-3.28L1.051,45.969a.728.728,0,1,1-.632-1.312l6.256-2.982L3.286,40.46a.727.727,0,0,1-.449-.929.751.751,0,0,1,.6-.48.856.856,0,0,1,.346.036l4.756,1.7,6.189-2.946L8.5,35.613a.718.718,0,0,1-.437-.935.738.738,0,0,1,.941-.437L16.6,36.955l5.879-2.8-6.3-2.247-2.758.723a.741.741,0,0,1-.905-.528.6.6,0,0,1-.012-.182.714.714,0,0,1,.534-.7l.692-.182L12.7,30.669a.732.732,0,0,1-.437-.935v-.006a.764.764,0,0,1,.6-.474.834.834,0,0,1,.346.036l3.031,1.087,7.2-1.883-5.691-3.851L9.925,26.162a.74.74,0,0,1-.862-.583.73.73,0,0,1,.571-.856l6.4-1.239-5.661-3.845-4.853.948H5.509a.753.753,0,0,1-.869-.577.736.736,0,0,1,.589-.862l3.426-.662L3,14.646a.721.721,0,0,1-.194-1.014.745.745,0,0,1,1.026-.188l5.74,3.887-.65-3.517a.738.738,0,1,1,1.452-.261l.9,4.938,5.679,3.845-1.178-6.469a.716.716,0,0,1,.6-.838.706.706,0,0,1,.711.267.62.62,0,0,1,.14.316l1.439,7.878,5.375,3.65L22.856,20.6l-2.01-2a.737.737,0,0,1,0-1.039c.049-.043.109-.067.158-.1a.744.744,0,0,1,.887.109l.5.5-.188-1.063a.727.727,0,0,1,.589-.85H22.8a.767.767,0,0,1,.717.273.96.96,0,0,1,.14.322l.571,3.14,5.242,5.242.516-6.809-5.236-5.958a.726.726,0,0,1,.067-1.033.739.739,0,0,1,1.039.073l4.282,4.871L30.661,9.5,27.405,5.8h.006a.726.726,0,0,1,.067-1.033.74.74,0,0,1,1.045.073l2.3,2.612L31.341.676a.734.734,0,0,1,1.464.115l-.522,6.863L35.04,5.347a.741.741,0,0,1,1.039.091.714.714,0,0,1,.109.753.667.667,0,0,1-.2.279L32.131,9.7l-.516,6.791,5.053-4.233a.739.739,0,0,1,1.039.085.693.693,0,0,1,.115.747.643.643,0,0,1-.207.285l-6.165,5.163-.492,6.444,5.12-4.282.747-2.733a.741.741,0,0,1,.9-.516,1.6,1.6,0,0,1,.176.091.716.716,0,0,1,.346.814l-.188.68.832-.692a.734.734,0,0,1,1.039.085h.006a.731.731,0,0,1,.109.747.765.765,0,0,1-.2.285l-2.466,2.059-1.95,7.119,6.214-2.952,2.575-7.477a.74.74,0,0,1,.935-.456.729.729,0,0,1,.462.929L43.507,24.8l6.183-2.94,1.6-4.646h.006a.734.734,0,0,1,.935-.449.724.724,0,0,1,.456.923l-1.13,3.286,6.171-2.94a.749.749,0,0,1,.99.34.74.74,0,0,1-.352.984l-6.256,2.976L55.5,23.538a.718.718,0,0,1,.443.935.709.709,0,0,1-.589.474.735.735,0,0,1-.346-.03l-4.762-1.7-6.2,2.946,6.232,2.223a.736.736,0,0,1,.449.935.751.751,0,0,1-.6.48.624.624,0,0,1-.346-.043l-7.592-2.709L36.31,29.843l6.3,2.247,2.764-.717a.752.752,0,0,1,.905.522.93.93,0,0,1,.006.182.722.722,0,0,1-.534.711l-.692.182,1.02.364a.735.735,0,0,1,.449.941H46.52a.746.746,0,0,1-.6.474.834.834,0,0,1-.346-.036l-3.037-1.087-7.185,1.883,5.679,3.851,7.823-1.518v.006a.731.731,0,1,1,.285,1.433l-6.39,1.239,5.667,3.839,4.853-.941v.006a.731.731,0,1,1,.292,1.433l-3.444.662,5.661,3.833a.723.723,0,0,1,.194,1.014M34.439,30.729l-2.691,1.282-.905.437.128.091.249.17.176.115,2.344,1.591L40.1,32.758ZM29.4,32.084l.073-.049-.006-.079-.079-.036-.067.049a.181.181,0,0,1,.006.079l.073.036m1.409-5.053-.225,2.952-.079,1,.14-.073.279-.134.194-.085,2.557-1.221L35.4,23.18ZM25.759,28.3l2.466,1.67.832.565.012-.158.024-.3.006-.213.225-2.812L24.69,22.432Zm-1.415,4.974,2.691-1.282.911-.437-.134-.091-.243-.17-.182-.115-2.344-1.591-6.353,1.664Zm3.638,3.7.219-2.946.085-1-.152.061-.267.134-.2.085L25.11,34.532l-1.725,6.286ZM33.024,35.7,30.57,34.04l-.838-.571-.012.152-.024.3-.018.213-.213,2.806,4.628,4.628Z"
                              transform="translate(0 -0.001)"/>
                    </g>
                </g>
            </svg>
        </div>;

        const btnDownload = started ? <a target="_blank" rel="noopener noreferrer" href={s.greeting['url_1080p_mp4']}><button>Скачать поздравление!</button></a> : '';

        const btn3D = isMac ? <a href="https://dl.dropboxusercontent.com/s/afg1q7y2ehjrzww/W-Hub-mac.zip?dl=0"><button>Скачать Елку-3D (MacOS)</button></a> : <a href="https://dl.dropboxusercontent.com/s/nst82ycqbubkdek/W-Hub_win.zip?dl=0"><button>Скачать Елку-3D (Win)</button></a>;

        const buttons = started && s.greeting ? <div className="greeting_buttons_wrapper">
            <button onClick={t.playGreeting}>Смотреть поздравление!</button>
            {btnDownload}
            {btn3D}

        </div> : loader;

        const modalContent = s.nowPlaying ? <Player url={s.nowPlaying} /> : '';

        const modal = s.nowPlaying ? <Modal modalContent="custom" customContent={modalContent} onModalClose={t.hideModal} /> : '';

        const cls_loaded = s.loaded ? 'loaded' : '';

        const waitingMessage = s.loaded && !started ? <div className="waiting_mode">
                <div className="waiting_message_wrapper">
                    <p>Поздравляем вас с наступающим Новым годом! Дедушка Мороз уже готовит ваше индивидуальное видеопоздравление. Обычно это занимает от нескольких минут до 24 часов.<br />Мы обязательно пришлем вам письмо, но вы так же можете обновить эту страницу через несколько минут, возможно, ваше поздравление уже будет готово!</p>

                    <p>Обращаем ваше внимание, что после просмотра вы сможете скачать поздравление на свой компьютер, а спектакль будет доступен до 09.01.2021</p>
                </div>
                {/*<div className="countdown_wrapper"><Countdown date={s.date} renderer={t.countdownRenderer} /></div>*/}
            </div> : '';

        let content = waitingMessage;

        if (started) {
            content = buttons;
        }

        if (s.orderStatus === 'pending') {
            content = <div className="payment_wrapper">
                <p>Уважаемый клиент, спасибо за регистрацию! Мы ожидаем поступление средств от вашего банка. Как только средства поступят, вы получите доступ к сервису.<br />
                    Если вы не проводили оплату, вы всегда можете сделать это воспользовавшись кнопкой ниже:</p>
                <button onClick={t.initPayment}>Оплатить!</button>
            </div>;
        }

        const purchaseModal = s.modalPurchaseLink ? <Modal modalContent={'purchase_link'} modalUrl={s.modalPurchaseLink} onModalClose={t.hideModal} /> : '';

        return (
            <div className={'greeting_wrapper ' + cls_loaded}>
                <div className={'player_wrapper ' + cls_global_playing}>
                    <div className="player_inner">
                        <GreetingPlayer
                            url="https://socialmsk20.videodedmoroz.ru/download?f=pc&t=%D0%9F%D0%BE%D0%B7%D0%B4%D1%80%D0%B0%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5+%D0%B4%D0%BB%D1%8F+%D0%90%D0%B0%D1%80%D0%BE%D0%BD%D0%B0&v=bGksUDYjlUC&_s=b154bafe3ed23400c3050546c3b3bb65"
                            playing={s.playing}
                            handlePlay={t.removeIce} handlePause={t.addIce}/>
                    </div>

                    <div className={'greeting_screen ' + cls_ice_hidden}>
                        <div className="greeting_gradient">
                            <div className={'gg_sizer ' + cls_scaled}>
                                <div className="g_red g_color"> </div>
                                <div className="g_green g_color"> </div>
                                <div className="g_blue g_color"> </div>
                            </div>
                        </div>
                        <div className="greeting_pattern">
                            {content}
                            {loader}
                        </div>
                    </div>
                </div>

                {modal}
                {purchaseModal}
            </div>
        );
    }
}

export default Greeting;
